/*
 * Layout for the tenant info section
 */

define(["marionette", "./template/tenantInfoTemplate.html"], function (
  Marionette,
  TenantInfoTemplate,
) {
  var TenantInfoView = {
    tenantInfoLayout: Marionette.ItemView.extend({
      template: TenantInfoTemplate,
      triggers: {
        "click #editTenantSettings": "edit:tenantSettings",
      },
    }),
  };

  return TenantInfoView;
});
